module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Oude-Kuststeen.47395eac.jpg";